import p5 from 'p5';
import 'p5/lib/addons/p5.sound';

export default function sketch(p) {
  let canvas;
  let mic;
  let fft;
  let bands = 64;
  let storedDataLen = 125;
  let spectrums;
  let waveforms;
  let currentSpectrum = 0;
  let spectrumColor = 'rgba(255, 0, 0, 0.8)';
  let waveformColor = 'rgba(255, 100, 20, 0.8)';
  let amplitude;
  let space = 20;

  function initializeStoredData() {
    return range(storedDataLen).map(x => range(bands).map(x => 0));
  }

  function range(x) {
    let ret = [];
    for (let i = 0; i < x; i++) {
      ret.push(i);
    }
    return ret;
  }

  p.setup = function setup() {
    canvas = p.createCanvas(window.innerWidth, window.innerHeight, p.WEBGL);
    mic = new p5.AudioIn();
    mic.start();
    amplitude = new p5.Amplitude();
    fft = new p5.FFT(0.8, bands);
    fft.setInput(mic);
    spectrums = initializeStoredData();
    waveforms = initializeStoredData();
    p.orbitControl();
  };

  function drawSpectrum(spectrum) {
    p.noFill();
    p.stroke(spectrumColor);
    p.beginShape();
    p.curveVertex(0, p.height);
    for (let i = 0; i < bands; i++) {
      let endX = p.map(i, 0, bands, 0, p.width);
      let endY = p.height - p.map(spectrum[i], 0, 255, 0, p.height);
      p.curveVertex(endX, endY);
    }
    p.curveVertex(p.width, p.height);
    p.endShape();
  }

  function drawWaveform(spectrum) {
    p.noFill();
    p.stroke(waveformColor);
    p.beginShape();
    p.curveVertex(0, p.height);
    for (let i = 0; i < bands; i++) {
      let endX = p.map(i, 0, bands, 0, p.width);
      let endY = p.map(spectrum[i], -1, 1, 0, p.height);
      p.curveVertex(endX, endY);
    }
    p.curveVertex(p.width, p.height);
    p.endShape();
  }

  p.draw = function draw() {
    p.clear();

    let cZ = p.frameCount * 0.005 * 100;
    let cX = cZ;
    if (cZ > 1000) {
      cZ = 1000;
    }
    const cX2 = Math.min(250, Math.max(-250, p.mouseX - p.width / 2));
    const cY2 = Math.min(300, Math.max(-50, p.mouseY - p.height / 2));
    console.log(cX2, cY2);
    p.camera(
      cX,
      0,
      cZ, // x, y, z
      cX2,
      cY2,
      0, // cX, cY, cZ
      0,
      1,
      0, // upX, upY, upZ
    );
    /*
    camera(
      0, 0, cY, // x, y, z
      0, 0, 0,  // cX, cY, cZ
      0, 0, 0   // upX, upY, upZ
    );
    */

    p.translate(-p.width / 2, -p.height / 2);

    const level = amplitude.getLevel();
    const size = 80 + 200 * level;

    p.ambientLight(255, 0, 10, 30);

    // translate(0, 0, -4 * storedDataLen - 10);
    // noFill();
    // stroke(0, 0, 255);
    // ellipse(width / 2, height / 2, size);
    // translate(0, 0, 4 * storedDataLen + 10);

    p.translate(0, -10);

    const spectrum = fft.analyze();
    const waveform = fft.waveform();

    spectrums[currentSpectrum] = spectrum;
    waveforms[currentSpectrum] = waveform;

    currentSpectrum = (currentSpectrum + 1) % storedDataLen;

    for (let i = 0; i < storedDataLen; i++) {
      let index = (storedDataLen - 1 - i + currentSpectrum) % storedDataLen;
      if (index < 0) {
        index = storedDataLen + index;
      }
      drawSpectrum(spectrums[index]);
      // p.translate(0, 0, -space * storedDataLen);
      // drawWaveform(waveforms[index]);
      // p.translate(0, 0, space * storedDataLen);
      p.translate(0, 0, -space);
    }
  };

  p.touchStarted = function touchStarted() {
    p.getAudioContext().resume();
  };
}



// WEBPACK FOOTER //
// ./src/sketches/frequency-in-space.js